/**
 * Filename: RightIconDP.js
 * component RightIconDP
 * RightIconDP is to create Datepicker element in the header panel
 */

import React, {Component} from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

class RightIconDP extends Component {

  constructor(props) {
    super(props)
    var moment = require('moment');
    require("moment/min/locales.min");
    moment.locale(this.props.locale);
    this.state = {
      startDate: moment()
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(date) {
    this.setState({
      startDate: date
    });
    this.props.callbackFromParent(date.toDate());
  }

  render() {
    return <DatePicker
      selected={this.state.startDate}
      onChange={this.handleChange}
      locale="es-MX"
      placeholderText="Fecha"
    />;
  }
}

export default RightIconDP;



// WEBPACK FOOTER //
// ./src/components/ui-components/rightIconDP.js